import { ProductType } from '@/generated/graphql/types';

const PRODUCT_TYPES = new Set<string>(Object.values(ProductType));

export const isProductType = (value: string): value is ProductType =>
  PRODUCT_TYPES.has(value);

type TProductRouteLoaderArgs = {
  params: {
    product?: string;
  };
};

export const productRouteLoader = ({ params }: TProductRouteLoaderArgs) => {
  if (!isProductType((params.product ?? '').toUpperCase())) {
    throw new Response(null, { status: 404 });
  }

  return null;
};
